<!-- Document Section start -->
@if (loaderIcon | async) {
  <app-loader></app-loader>
}
<div class="doc_outer">
  <div class="row mx-0 w-100 ps-3 pe-3" style="margin-top: -40px;">
    <app-call-script [section]="section" style="width: 100%;"></app-call-script>
  </div>
  <div class="row mx-0 justify-content-center mt-3">
    <div class="doc_container">
      <h5>Document</h5>
      <div class="d-flex justify-content-center align-items-center mt-3">
        <label class="pure-material-checkbox mb-0 mt-2">
          <input type="checkbox" class="custom-control-input" [disabled]="disableSelectAll || disableCheckAll()"
            (change)="selectAll($event)" [(ngModel)]="selectAllCB">
            <span>Select All</span>
          </label>
          <div class="ms-3">
            <button type="button" class="btn btn-primary w-100" [disabled]="disableProcessAll()"
            (click)="subjectProcessAll.next(true)">Process All</button>
          </div>
        </div>
        <div class="normal_table mt-4">
          <table class="table table-responsive table-hover mb-0">
            <colgroup>
            <col width="10%">
            <col width="10%">
            <col width="50%">
            <col width="30%">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">&nbsp;</th>
              <th scope="col">SI.No</th>
              <th scope="col">Document</th>
              <th scope="col">&nbsp;</th>
            </tr>
          </thead>
        </table>
        <div id="Doc_scroll">
          <table class="table table-responsive table-hover mb-0">
            <colgroup>
            <col width="10%">
            <col width="10%">
            <col width="50%">
            <col width="30%">
          </colgroup>
          @if (documentList.length > 0) {
            <tbody>
              @for (docItem of documentList; track docItem) {
                <tr>
                  <td class="text-center">
                    <label class="pure-material-checkbox mt-2 mb-0 without-text">
                      <input type="checkbox" class="custom-control-input"
                        [disabled]="docItem.disableSelect || disableButtons(docItem)" [(ngModel)]="docItem.select"
                        (ngModelChange)="individualSelect($event,docItem.slNo)">
                        <span></span>
                      </label>
                    </td>
                    <td class="align-middle text-center">{{docItem.slNo}}</td>
                    <td>
                      <select class="form-select" [disabled]="disableBasedOnSetting(docItem)"
                        (change)="changeDocument($event.target.value, docItem.slNo, docItem.TemplateId, onApproveFlag, onEmailFlag)"
                        [title]="getLetterName(docItem.LetterId)">
                        <option value="0" style="display:none">Select</option>
                        @for (item of dropdownLettersList; track item) {
                          <option [value]="item.LetterId"
                            [selected]="item.LetterId == docItem.LetterId" [disabled]="disableDocumentOpt(item.LetterId)"
                            [ngStyle]="{'display':disableDocumentOpt(item.LetterId) ? 'none' : '' }">
                            {{item.LetterName}}
                          </option>
                        }
                      </select>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-between align-items-center">
                        <div style="display: flex; flex-wrap: nowrap; justify-content: space-between; width: 100%; gap: 10px; overflow: hidden;">
                          <div style="flex: 1; margin-bottom: 10px;">
                            @if (!docItem.obtainSignature && !docItem.Processed && !docItem.isDocumentFailed) {
                              <button type="button" class="btn btn-primary w-100"
                                (click)="subjectProcess.next(docItem.slNo)"
                              [disabled]="!docItem.isApprove || disableButtons(docItem)">Process</button>
                            }
                            @if (docItem.obtainSignature && !docItem.Processed && !docItem.isDocumentFailed && !isCallCenterGroup && docItem.unsignedDocGenerated) {
                              <button type="button" class="btn btn-primary w-100"
                              (click)="onRecapture(docItem)">Recapture</button>
                            }
                            @if (docItem.obtainSignature && !docItem.Processed && !docItem.isDocumentFailed && isCallCenterGroup && docItem.unsignedDocGenerated) {
                              <button type="button" class="btn btn-primary w-100"
                              [disabled]="isCallCenterGroup">Recapture</button>
                            }
                            @if (docItem.obtainSignature && !docItem.Processed && !docItem.isDocumentFailed && !isCallCenterGroup && !docItem.unsignedDocGenerated) {
                              <button type="button" class="btn btn-primary w-100"
                              (click)="onApprove(docItem.slNo, docItem.TemplateId)" [disabled]="!docItem.isApprove">Approve</button>
                            }
                            @if (docItem.obtainSignature && !docItem.Processed && !docItem.isDocumentFailed && isCallCenterGroup && !docItem.unsignedDocGenerated) {
                              <button type="button" class="btn btn-primary w-100"
                              [disabled]="isCallCenterGroup">Approve</button>
                            }
                            @if (docItem.Processed && !docItem.isDocumentFailed) {
                              <img class="valueTemp" src="../../../../../assets/images/checked.svg" height="25px" width="25px" alt="processed"
                                style="margin-top:6px;" />
                            }
                            @if (docItem.isDocumentFailed) {
                              <img class="valueTemp" src="../../../../../assets/images/cancel.svg" height="25px" style="margin-top:6px;"
                                width="25px" />
                            }
                          </div>
                          <div style="flex: 1; margin-bottom: 10px;">
                            @if (docItem.Processed && docItem.obtainSignature) {
                              <img class="valueTemp" src="../../../../../assets/images/checked.svg" height="25px" style="margin-top:6px;"
                                width="25px" />
                            }
                            @if (docItem.isDocumentFailed && docItem.obtainSignature) {
                              <img class="valueTemp" src="../../../../../assets/images/cancel.svg" height="25px" style="margin-top:6px;"
                                width="25px" />
                            }
                            @if (!docItem.Processed && !docItem.isDocumentFailed && docItem.unsignedDocGenerated) {
                              <button class="btn btn-primary w-100" type="button" (click)="onResend(docItem)"
                              [disabled]="disableButtonsEsign(docItem) || !docItem.obtainSignature || (!docItem.isEmailTemplateDefined && docItem.isSMSTemplateDefined && !this.sendSMSAlert) || (!docItem.isEmailTemplateDefined && !docItem.isSMSTemplateDefined)">Resend</button>
                            }
                            @if ((!docItem.Processed && !docItem.isDocumentFailed && !docItem.unsignedDocGenerated) ||
                              !docItem.obtainSignature) {
                              <button class="btn btn-primary w-100" type="button" (click)="onButtonClick(docItem)"
                              [disabled]="disableButtonsEsign(docItem) || !docItem.obtainSignature || (!docItem.isEmailTemplateDefined && docItem.isSMSTemplateDefined && !this.sendSMSAlert) || (!docItem.isEmailTemplateDefined && !docItem.isSMSTemplateDefined)">{{ getButtonLabel(docItem) }}</button>
                            }
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="payment_bottom_button">
    <div class="pay_rgt_butt">
      <button type="button" class="btn btn-primary" (click)="clickNextButton()"
      [disabled]="disableNextButton()">Next</button>
    </div>
  </div>
</div>
<!-- Document Section end -->

<div bsModal #documentPopup="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <form #printform="ngForm">
        <div class="modal-body">
          <div class="row mx-0">
            <div class="payment_successful_txt">
              <app-success-tick></app-success-tick><span>Document Processed</span>
            </div>
          </div>

          <div class="row  justify-content-between">
            <div class="col-md-4">
              <label class="pure-material-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="emailCheckBox" name="emailCheckBox"
                  (change)="onEmailCheck($event)" [disabled]="isEmailCheckBoxDisabled()">
                  <span>Email</span>
                </label>
                <div class="row mx-0 mt-2">
                  @if (transactionType != 43) {
                    <div>
                      <input type="text" class="form-control" name="email" [(ngModel)]="emailBox" [pattern]="emailPattern"
                        [ngModelOptions]="{standalone: true}" [title]="emailBox" [disabled]="!enableEmail" #email="ngModel">
                        @if (email.errors !== null &&(email.dirty ||email.touched)) {
                          <div class="alert alert-danger">
                            @if (email.errors.pattern) {
                              <span i18n="@@Email_Error"> Enter valid E-Mail Id <br>
                    </span>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (emailTemplates.length && (transactionType == 27 || transactionType == 17)) {
                      <div class="mt-3">
                        <select class="form-select" (change)="onChangeEmailTemplate($event.target.value)">
                          @for (emailTemp of emailTemplates; track emailTemp) {
                            <option [value]="emailTemp.LetterId" [selected]="emailTemp.DefaultTemplate"
                            >{{emailTemp.LetterName}}</option>
                          }
                        </select>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-md-4 doc_opt">
                  <label class="pure-material-checkbox">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="isPrintChecked" name="isPrintChecked"
                      (change)="onPrintCheck($event)">
                      <span>Print</span>
                    </label>
                  </div>
                  <div class="col-md-4 doc_opt">
                    <label class="pure-material-checkbox checkbox-Margin">
                      <input type="checkbox" class="custom-control-input" [(ngModel)]="isSMSChecked" name="isSMSChecked"
                        (change)="onsmscheck($event)" [disabled]="isSmsDisabled">
                        <span>SMS</span>
                      </label>
                      @if (transactionType != 43) {
                        <div class="outer_border">
                          <ejs-maskedtextbox [mask]="PhoneNumberMask" name="sms" id="inputCellPhone" [(ngModel)]="phoneNumber"
                            [disabled]="!enablesms" (keyup)="onkeysms($event)">
                          </ejs-maskedtextbox>
                        </div>
                      }
                      @if (smsTemplates.length && (transactionType == 27 || transactionType == 17)) {
                        <div>
                          <select class="form-select" (change)="onChangeSMSTemplate($event.target.value)">
                            @for (smsTemp of smsTemplates; track smsTemp) {
                              <option [value]="smsTemp.LetterId" [selected]="smsTemp.DefaultTemplate"
                              >{{smsTemp.LetterName}}</option>
                            }
                          </select>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary" data-dismiss="modal"
                    [disabled] ="disabledOkButton()"
                  (click)="goToHost()">OK</button>
                </div>
              </form>
            </div>
          </div>
        </div>


        <div bsModal #printPreviewPopup="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
          aria-labelledby="dialog-sizes-name1">
          <div class="modal-dialog modal-dialog-centered modal-fullSize  modal-lg modal-xxl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Preview</h5>
                <button type="button" class="close" (click)="redirectToMaster()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div>
                  <div class="row mx-0 align-items-center justify-content-center receiptdiv" id="recieptContainerDocument"
                    style="min-height: 350px">
                  </div>
                  @if (isDocumentDownload) {
                    <div class="row mx-0 align-items-center justify-content-center downloadbuttondiv">
                      <button class="btn btn-primary" type="button" (click)="downloadDocument()">Click here to download the PDF file</button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>


          <!-- email popup -->
          <ng-template #EsignatureModal let-modal>
            @if (unitInfoLoader | async) {
              <app-unitInfoLoader></app-unitInfoLoader>
            }
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div class="modal-content">
                <div>
                  <form [formGroup]="sendEmailForm">
                    <div class="email_top_section">
                      <div class="send_butt">
                        <button>
                          <i class="send_ico">&nbsp;</i>
                          <span>Send</span>
                        </button>
                      </div>
                      <div class="to_cc_sec">
                        <div class="to_sec">
                          <button>To</button>
                          <div class="toemails"><input formControlName="toAddress" type="text"
                          class="form-control custom-inputBox" /></div>
                        </div>
                        <div class="subject_sec">
                          <button>Cc</button>
                          <div class="toemails"><input type="text" formControlName="ccAddress"
                          class="form-control custom-inputBox" /></div>
                        </div>
                        <div class="subject_sec">
                          <div class="sub_text">Subject</div>
                          <div class="toemails  border-0">{{currentSubject}}</div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="modal-body">
                  <div class="email_mid_section customRichtextEditor">
                    <ejs-richtexteditor class="height400 mt-3" #defaultRTE [(value)]="rteValue"
                      readonly="true" [toolbarSettings]='toolbarConfig'>
                    </ejs-richtexteditor>
                  </div>
                </div>
                <div class="modal-footer">
                  <div class="bottom_button mt-3">
                    <button type="button" class="btn btn-primary" (click)="sendEmailWithBody()"
                    [disabled]="!sendEmailForm.valid">Send</button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template #OneLocalPopup>
            <div class="modal-body ptb24">
              <p class="mb-0">
                Do you want to send the Tenant Details to Reputation Management?
              </p>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary me-3" type="button"
              (click)="openNotesOneLocalPopup(captureNotesOneLocal)">No</button>
              <button class="btn btn-primary" type="button" (click)="OneLocalPopOKAction()">Yes</button>
            </div>
          </ng-template>

          <ng-template #captureNotesOneLocal>
            <div class="modal-header">
              <h5 class="modal-title">Add Notes</h5>
            </div>
            <div class="modal-body ">
              <textarea rows="3" class="form-control" [(ngModel)]="notesOneLocalCancel"></textarea>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="button" (click)="saveOneLocalNotes()"
              [disabled]="notesOneLocalCancel.trim()==''">Save</button>
            </div>
          </ng-template>

          <!---EMAIL/SMS POPUP-->
          <ng-template #documentemailsmspopup let-modal>
            <app-email-sms-popup
              [emailBox]="emailAndSmsBox"
              [phoneNumber]="emailAndSmsBoxPhoneNumber"
              (onSubmit)="sendEmailandsms($event)">
            </app-email-sms-popup>
          </ng-template>

